import React, { useEffect, useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import "../styles/Modal.css";

const VideoModal = ({ show, handleClose, videos = [], title }) => {
    const [index, setIndex] = useState(0);

    // Volver al primer video cada vez que se abre el reproductor
    useEffect(() => {
      if (show) setIndex(0);
    }, [show]);

    // Escape para cerrar, flechas para cambiar de video, y bloqueo del scroll
    useEffect(() => {
      if (!show) return;

      const handleKeyDown = (e) => {
        if (e.key === 'Escape') handleClose();
        if (videos.length < 2) return;
        if (e.key === 'ArrowLeft') {
          setIndex((i) => (i - 1 + videos.length) % videos.length);
        }
        if (e.key === 'ArrowRight') {
          setIndex((i) => (i + 1) % videos.length);
        }
      };

      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);

      return () => {
        window.removeEventListener('keydown', handleKeyDown);
        document.body.style.overflow = previousOverflow;
      };
    }, [show, videos.length, handleClose]);

    if (!show || videos.length === 0) return null;

    const current = videos[index] || videos[0];
    const hasMany = videos.length > 1;

    return (
      <div
        className="bmodal"
        role="dialog"
        aria-modal="true"
        aria-label={`${title} videos`}
        onClick={(e) => {
          if (e.target === e.currentTarget) handleClose();
        }}
      >
        <div className="bmodal__panel">
          <div className="bmodal__head">
            <div>
              <span className="bmodal__eyebrow">
                {videos.length} {videos.length === 1 ? 'video' : 'videos'}
              </span>
              <h3 className="bmodal__title">{title}</h3>
            </div>
            <button
              type="button"
              className="bmodal__close"
              onClick={handleClose}
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </div>

          <div className="bmodal__body">
            <div className="vmodal__stagewrap">
            <div className="vmodal__stage">
              <iframe
                key={current.id}
                src={`https://www.youtube.com/embed/${current.id}?autoplay=1&rel=0`}
                title={current.title || `${title} video`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>

              {hasMany && (
                <>
                  <button
                    type="button"
                    className="vmodal__nav vmodal__nav--prev"
                    onClick={() =>
                      setIndex((i) => (i - 1 + videos.length) % videos.length)
                    }
                    aria-label="Previous video"
                  >
                    <ChevronLeft size={22} />
                  </button>
                  <button
                    type="button"
                    className="vmodal__nav vmodal__nav--next"
                    onClick={() => setIndex((i) => (i + 1) % videos.length)}
                    aria-label="Next video"
                  >
                    <ChevronRight size={22} />
                  </button>
                </>
              )}
            </div>
            </div>

            <div className="vmodal__now">
              <h4>{current.title || title}</h4>
              {hasMany && (
                <span className="vmodal__pos">
                  {index + 1} / {videos.length}
                </span>
              )}
            </div>

            {hasMany && (
              <div className="vmodal__rail">
                {videos.map((video, i) => (
                  <button
                    type="button"
                    key={`${video.id}-${i}`}
                    className={`vmodal__item${i === index ? ' is-active' : ''}`}
                    onClick={() => setIndex(i)}
                    aria-current={i === index ? 'true' : undefined}
                  >
                    <span className="vmodal__thumb">
                      <img
                        src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
                        alt=""
                        loading="lazy"
                      />
                      {i === index && (
                        <span className="vmodal__badge">Playing</span>
                      )}
                    </span>
                    <span className="vmodal__label">
                      {video.title || `Video ${i + 1}`}
                    </span>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
};

export default VideoModal;
